import React from 'react';

import { 
    ThemeProvider, 
    styled 
} from '../../../components-core/packages/components-core/dist/theme-provider/index';
import { 
    Container, 
    ContainerPadding,
} from '../../../components-core/packages/components-core/dist/container/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Checkmark } from '../../../components-core/packages/icons-core/dist/Checkmark/index';


const ColorContainer = styled.div`
    background-image: url(${props => props.backgroundImage});
    width: 76px;
    height: 76px;

    min-width: 76px;
    min-height: 76px;

    margin: 10px 6px 10px 6px;
    display: inline-block;

    border-radius: 100%;


    @media screen and (max-width: 560px) {
        width: 56px;
        height: 56px;

        min-width: 56px;
        min-height: 56px;
    }
`;

const ColorContainerSelected = styled.div`
    padding: 6px;

    border-width: 2px;
    border: solid;
    border-radius: 100%;
    border-color: #dfe4e8;
    
    margin: 8px 6px 8px 6px;

    display: inline-block;
`;

const ColorContainerSelectedInner = styled.div`
    background-image: url(${props => props.backgroundImage});
    width: 60px;
    height: 60px;
    min-width: 60px;
    min-height: 60px;

    border-radius: 100%;

    @media screen and (max-width: 560px) {
        width: 42px;
        height: 42px;

        min-width: 42px;
        min-height: 42px;
    }
`;


const ColorTick = styled.div`
    height: 40px;
    width: 40px;
    min-width: 40px;
    max-width: 40px;
    min-height: 40px;
    max-height: 40px;

    background-color: #dfe4e8;
    border-radius: 100%;

    position: absolute;

    display: flex;
    align-items: center;
    justify-content: center;

`;


class Color extends React.Component {

    constructor(props) {
        super(props);
    }

    renderSelected() {
        return (
            <ThemeProvider theme={'image'}>
                <Container 
                    padding={{
                        left: {
                            [Breakpoints.default]: this.props.index === 0 ? ContainerPadding.grid002 : null,
                            [Breakpoints.b560]: null
                        },
                    }} 
                >
                    <ColorTick>
                        <Checkmark variant={'small'} />
                    </ColorTick>
                    <ColorContainerSelected>
                        <ColorContainerSelectedInner backgroundImage={this.props.colorImage} />
                    </ColorContainerSelected>
                </Container>
            </ThemeProvider>
        )
    }

    renderNonSelected() {
        return (
            <Container 
                padding={{
                    left: {
                        [Breakpoints.default]: this.props.index === 0 ? ContainerPadding.grid002 : null,
                        [Breakpoints.b560]: null
                    },
                    right: {
                        [Breakpoints.default]: this.props.dataLength - 1 === this.props.index ? ContainerPadding.grid002 : null,
                        [Breakpoints.b560]: null
                    }
                }} 
            >
                <ColorContainer 
                    cursor={'pointer'} 
                    onClick={() => this.props.onClick()}    
                    backgroundImage={this.props.colorImage}
                />
            </Container>
        )
    }

    render() {
        return (
            <div style={{ position: 'relative' }} >
                {
                    this.props.index === this.props.selectedIndex ? 
                    this.renderSelected() : 
                    this.renderNonSelected()
                }
            </div>
        )
    }
}

export default Color;